// components/StreamingChannels.js
import React from 'react';
import { Box, Typography, Button, Grid, styled } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import games from '../utils/games';
import barItems from '../utils/barItems';

function StreamingChannels() {
  return (
    <Box sx={{ mb: 4, maxWidth: '100%' }}>
      {/* Games Section */}
      <Grid item xs={12}>
        <Box
          sx={{
            color: '#ffffff',
            textAlign: 'center',
            borderRadius: 2,
            mt: 2,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Наши Игры
          </Typography>
          <Swiper
            pagination={{
              dynamicBullets: true,
              clickable: true,
              renderBullet: (index, className) =>
                `<span class="${className}" style="background-color: ${
                  className.includes('swiper-pagination-bullet-active')
                    ? '#ff7f00'
                    : '#ffffff'
                };"></span>`,
            }}
            autoplay={{ delay: 1700, disableOnInteraction: false }} // Set autoplay
            modules={[Pagination, Autoplay]}
            spaceBetween={5}
            slidesPerView={1}
            breakpoints={{
              600: {
                slidesPerView: 1,
              },
            }}
          >
            {games.map((game, index) => (
              <SwiperSlide key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    borderRadius: 2,
                    boxShadow: 3,
                    minHeight: 220,
                    padding: 2,
                  }}
                >
                  <img
                    src={game.image}
                    alt={game.title}
                    style={{ width: '100%', borderRadius: 8, marginBottom: 10 }}
                  />
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 'bold' }}
                  >
                    {game.title}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {game.description}
                  </Typography>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Grid>

      {/* Vape Bar Section */}
      <Grid container spacing={2}>
        {barItems.map((item, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box
              sx={{
                color: '#ffffff',
                textAlign: 'center',
                borderRadius: 2,
                mt: 2,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                  borderRadius: 8,
                  marginBottom: 8,
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  fontWeight: 'bold',
                  textShadow: '1px 1px 5px rgba(0, 0, 0, 0.7)',
                }}
              >
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {item.description}
              </Typography>
              {item.items && (
                <Box sx={{ width: '100%', mb: 1, textAlign: 'left' }}>
                  {item.items.map((subItem, subIndex) => (
                    <Box
                      key={subIndex}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 1,
                        padding: '10px',
                        borderRadius: '4px',
                        boxShadow: 1,
                        transition: 'background-color 0.3s', // Transition for hover effect
                        '&:hover': {
                          backgroundColor: '#6a6a6a', // Highlight on hover
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 'bold', color: '#ffffff' }}
                      >
                        {subItem.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 'bold', color: '#a4a6a5' }} // Highlight price color
                      >
                        {subItem.price}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
              {item.rules && (
                <Box sx={{ width: '100%', mb: 1, textAlign: 'center' }}>
                  {item.rules.map((rule, ruleIndex) => (
                    <Typography
                      key={ruleIndex}
                      variant="body2"
                      sx={{ color: '#e0e0e0' }}
                    >
                      {rule}
                    </Typography>
                  ))}
                </Box>
              )}
              <StyledButton
                color="#e0e0e0"
                sx={{
                  mt: 2,
                }}
                href="tel:+996705130070"
              >
                Узнать больше
              </StyledButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default StreamingChannels;

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
  fontWeight: 600,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 1),
  textTransform: 'none',
  color: theme.palette.primary.contrastText,
  background: 'linear-gradient(135deg, #750fb4, #750fb4)',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #600896d2, #600896d2)',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
  },
}));
